export default {
  data() {
    return {
      noOfProductsToDisplay: this.$device.isDesktopOrTablet ? 4 : 3
    };
  },

  beforeMount() {
    const checkMobile = window.matchMedia('(max-width: 768px)');
    // const checkTablet = window.matchMedia('(min-width: 501px) and (max-width: 768px)');
    const checkDesktop = window.matchMedia('(min-width: 769px)');

    checkMobile.addEventListener('change', this.handleMobileScreenChange);
    // checkTablet.addEventListener('change', this.handleTabletScreenChange);
    checkDesktop.addEventListener('change', this.handleDesktopScreenChange);

    this.handleMobileScreenChange(checkMobile);
    // this.handleTabletScreenChange(checkTablet);
    this.handleDesktopScreenChange(checkDesktop);
  },

  methods: {
    handleMobileScreenChange(e) {
      if (e.matches) {
        this.noOfProductsToDisplay = 3;
      }
    },

    // handleTabletScreenChange(e) {
    //   if (e.matches) {
    //     this.noOfProductsToDisplay = 3;
    //   }
    // },

    handleDesktopScreenChange(e) {
      if (e.matches) {
        this.noOfProductsToDisplay = 4;
      }
    }
  }
};
